import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Autocomplete,
  Button,
  Card,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../common/SnackUI";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DevTool } from "@hookform/devtools";
import AppbarUI from "../../common/AppbarUI";
import BodyWapperUI from "../../common/BodyWapperUI";
import DrawerUI from "../../common/DrawerUI";
import { singleBankAction } from "../../redux/toolkit/accountDetail.jsx/singlebank";
import { editBankAction } from "../../redux/toolkit/accountDetail.jsx/editbank";
import LabelText from "../../common/LabelText";

const app_schema = yup
  .object()
  .shape({
    holder_name: yup
      .string()
      .required("Holder Name is required.")
      .matches(
        /^[A-Za-z\s]+$/,
        "Holder Name should not contain numbers or special characters."
      ),
    account_no: yup
      .number()
      .typeError("Account Number must be a number")
      .required("Account Number is required.")
      .nullable(),
    account_type: yup.string().required("Account type is required"),
    bussiness_name: yup.string().required("Business Name is Required"),
    country: yup.string().required("Country is Required"),
    address: yup.string().required("address is Required"),
    address2: yup.string().required("address2 is Required"),
    city: yup.string().required("city is Required"),
    region: yup.string().required("Region is Required"),
    postal_code: yup
      .string()
      .matches(/^\d{6}$/, "Postal code must be exactly 6 digits")
      .required("Postal code is required"),
    branch: yup.string().required("Branch is Required"),
    ifcs_code: yup.string().required("IFSC Code is Required"),
  })
  .required();

export default function UpdateBankDetail() {
  const {
    register,
    control,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(app_schema),
    defaultValues: {},
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const bank_id = searchParams.get("bank_id");
  const [accountType, setAccountType] = useState();
  const [snakbar, setSnakeBar] = useState(false);
  const appCategory = useSelector((state) => state.editBank);
  const { status, data, message, loading } = appCategory;
  const singleBank = useSelector((state) => state.singleBank);
  const {
    status: appStatus,
    data: appData,
    message: appMsg,
    loading: appLoad,
  } = singleBank;
  const accTypeArr = ["Individual", "Business"];

  useEffect(() => {
    dispatch(singleBankAction(bank_id));
  }, [dispatch]);

  useEffect(() => {
    let defaultValues = {};
    defaultValues.account_no = appData.account_no;
    defaultValues.account_type = appData.account_type;
    defaultValues.address = appData.address;
    defaultValues.address2 = appData.address2;
    defaultValues.branch = appData.branch;
    defaultValues.city = appData.city;
    defaultValues.country = appData.country;
    defaultValues.holder_name = appData.holder_name;
    defaultValues.postal_code = appData.postal_code;
    defaultValues.region = appData.region;
    defaultValues.bussiness_name = appData.bussiness_name;
    defaultValues.ifcs_code = appData.ifcs_code;
    setAccountType(appData.account_type);
    reset({ ...defaultValues });
  }, [appData]);

  const handleAppSubmit = async (data) => {
    const appStore = await dispatch(
      editBankAction({ bank_id: bank_id, ...data, account_type: accountType })
    );
    setSnakeBar(true);
    setTimeout(() => {
      navigate("/payouts");
    }, 1000);
  };

  return (
    <>
      <AppbarUI />
      <DrawerUI />
      <BodyWapperUI>
        {/* <Card elevation={0} sx={{ borderRadius: "11px", border:"1px solid #000", p: 5 }}>
          <Typography fontWeight={600} variant="h5" sx={{ mb: 5 }}>
            Update Bank Detail
          </Typography>
          <form onSubmit={handleSubmit(handleAppSubmit)}>
            <Stack spacing={3}>
              <Stack
                direction="row"
                spacing={10}
                justifyContent="center"
                alignItems="center"
              >
                  <Grid xs={3.5} container>
                  <LabelText text="Branch" />
                <Autocomplete
                size="small"
                  disablePortal
                  options={accTypeArr}
                  defaultValue={appData.account_type}
                  onChange={(event, value) => {
                    setAccountType(value);
                    setValue("account_type", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                  onInputChange={(event, newInputValue) => {
                    setAccountType(newInputValue);
                  }}
                  sx={{ width: 450 }}
                  InputLabelProps={{ shrink: true }}
                  {...register("account_type")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      error={errors?.account_type?.message}
                      helperText={errors?.account_type?.message}
                    />
                  )}
                />
                  </Grid>
                <Grid xs={3.5} container>
                  <LabelText text="Holder Name" />
                  <TextField
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    {...register("holder_name")}
                    error={errors?.holder_name?.message}
                    helperText={errors?.holder_name?.message}
                    style={{ width: "450px" }}
                  />
                </Grid>
                <Grid xs={3.5} container>
                  <LabelText text="Account Number" />
                  <TextField
                   size="small"
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    {...register("account_no")}
                    error={errors?.account_no?.message}
                    helperText={errors?.account_no?.message}
                    style={{ width: "450px" }}
                  />
                </Grid>
              </Stack>

              <Stack
                direction="row"
                spacing={10}
                justifyContent="center"
                alignItems="center"
              >
                 <Grid xs={3.5} container>
                  <LabelText text="IFSC code" />
                <TextField
 size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("ifcs_code")}
                  error={errors?.ifcs_code?.message}
                  helperText={errors?.ifcs_code?.message}
                  style={{ width: "450px" }}
                />
                  </Grid>

                  <Grid xs={3.5} container>
                  <LabelText text="Business Name" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("bussiness_name")}
                  error={errors?.bussiness_name?.message}
                  helperText={errors?.bussiness_name?.message}
                  style={{ width: "450px" }}
                />
                  </Grid>
                
                  <Grid xs={3.5} container>
                  <LabelText text="Country" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("country")}
                  error={errors?.country?.message}
                  helperText={errors?.country?.message}
                  style={{ width: "450px" }}
                />
                  </Grid>
              </Stack>
              <Stack
                direction="row"
                spacing={10}
                justifyContent="center"
                alignItems="center"
              >
                 <Grid xs={3.5} container>
                  <LabelText text="Address" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("address")}
                  error={errors?.address?.message}
                  helperText={errors?.address?.message}
                  style={{ width: "450px" }}
                />
                  </Grid>
                  <Grid xs={3.5} container>
                  <LabelText text="Address 2" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("address2")}
                  error={errors?.address2?.message}
                  helperText={errors?.address2?.message}
                  style={{ width: "450px" }}
                />
                  </Grid>
                  <Grid xs={3.5} container>
                  <LabelText text="City" />
                <TextField
  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("city")}
                  error={errors?.city?.message}
                  helperText={errors?.city?.message}
                  style={{ width: "450px" }}
                />
                  </Grid>
              </Stack>

              <Stack
                direction="row"
                spacing={10}
                justifyContent="center"
                alignItems="center"
              >
                  <Grid xs={3.5} container>
                  <LabelText text="Region" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("region")}
                  error={errors?.region?.message}
                  helperText={errors?.region?.message}
                  style={{ width: "450px" }}
                />
                  </Grid>
                  <Grid xs={3.5} container>
                  <LabelText text="Postal code" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("postal_code")}
                  error={errors?.postal_code?.message}
                  helperText={errors?.postal_code?.message}
                  style={{ width: "450px" }}
                />
                  </Grid>
                  <Grid xs={3.5} container>
                  <LabelText text="Branch" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("branch")}
                  error={errors?.branch?.message}
                  helperText={errors?.branch?.message}
                  style={{ width: "450px" }}
                />
                  </Grid>
              </Stack>

              <Grid  container>
                  <Button
                   sx={{
                    
                    textTransform: "none",
                    background:" linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)"
                  }}
                  variant="contained" type="submit">
                  Update Bank Detail
                </Button>
                  </Grid>
            </Stack>
          </form>
        </Card> */}

        <Card
          elevation={0}
          sx={{ borderRadius: "11px", border: "1px solid #000", p: 5 }}
        >
          <Typography fontWeight={600} variant="h5" sx={{ mb: 5 }}>
            Update Bank Detail
          </Typography>
          <form onSubmit={handleSubmit(handleAppSubmit)}>
            <Grid container spacing={3}>
              {/* Row 1 */}
              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Branch" />
                <Autocomplete
                  size="small"
                  disablePortal
                  options={accTypeArr}
                  defaultValue={appData.account_type}
                  onChange={(e, value) => {
                    setAccountType(value);
                    setValue("account_type", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                  onInputChange={(e, newInputValue) =>
                    setAccountType(newInputValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      error={!!errors?.account_type}
                      helperText={errors?.account_type?.message}
                      fullWidth
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Holder Name" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("holder_name")}
                  error={!!errors?.holder_name}
                  helperText={errors?.holder_name?.message}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Account Number" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("account_no")}
                  error={!!errors?.account_no}
                  helperText={errors?.account_no?.message}
                  fullWidth
                />
              </Grid>

              {/* Row 2 */}
              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="IFSC code" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("ifcs_code")}
                  error={!!errors?.ifcs_code}
                  helperText={errors?.ifcs_code?.message}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Business Name" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("bussiness_name")}
                  error={!!errors?.bussiness_name}
                  helperText={errors?.bussiness_name?.message}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Country" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("country")}
                  error={!!errors?.country}
                  helperText={errors?.country?.message}
                  fullWidth
                />
              </Grid>

              {/* Row 3 */}
              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Address" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("address")}
                  error={!!errors?.address}
                  helperText={errors?.address?.message}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Address 2" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("address2")}
                  error={!!errors?.address2}
                  helperText={errors?.address2?.message}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="City" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("city")}
                  error={!!errors?.city}
                  helperText={errors?.city?.message}
                  fullWidth
                />
              </Grid>

              {/* Row 4 */}
              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Region" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("region")}
                  error={!!errors?.region}
                  helperText={errors?.region?.message}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Postal Code" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("postal_code")}
                  error={!!errors?.postal_code}
                  helperText={errors?.postal_code?.message}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <LabelText text="Branch" />
                <TextField
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  {...register("branch")}
                  error={!!errors?.branch}
                  helperText={errors?.branch?.message}
                  fullWidth
                />
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    textTransform: "none",
                    background:
                      "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)",
                  }}
                >
                  Update Bank Detail
                </Button>
              </Grid>
            </Grid>
          </form>
        </Card>
      </BodyWapperUI>
      {snakbar && (
        <SnackBarUI
          state={snakbar}
          setState={setSnakeBar}
          status={status}
          message={message}
        />
      )}
      <DevTool control={control} />
    </>
  );
}
